import api from "./api";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINT_VEHICLES_QUERY = `${API_URL_VERSION}consulta-veiculos`;
export const ENDPOINT_VEHICLES_QUERY_SENATRAN = `${ENDPOINT_VEHICLES_QUERY}/senatran`;
export const ENDPOINT_VEHICLES_QUERY_BY_PLATE = `${ENDPOINT_VEHICLES_QUERY}/placa`;
export const ENDPOINT_VEHICLES_QUERY_BY_PLATE_SENATRAN = `${ENDPOINT_VEHICLES_QUERY_SENATRAN}/placa`;
export const ENDPOINT_VEHICLES_QUERY_BY_CHASSIS = `${ENDPOINT_VEHICLES_QUERY}/chassi`;
export const ENDPOINT_VEHICLES_QUERY_BY_CHASSIS_SENATRAN = `${ENDPOINT_VEHICLES_QUERY_SENATRAN}/chassi`;
export const ENDPOINT_VEHICLES_QUERY_BY_CPFCNPJ = `${ENDPOINT_VEHICLES_QUERY}/cpf-cnpj`;
export const ENDPOINT_VEHICLES_QUERY_BY_CPFCNPJ_SENATRAN = `${ENDPOINT_VEHICLES_QUERY_SENATRAN}/cpf-cnpj`;
export const ENDPOINT_DRIVERS_QUERY = `${API_URL_VERSION}consultas/condutores/cpf`;
export const ENDPOINT_DRIVERS_QUERY_SENATRAN = `${ENDPOINT_DRIVERS_QUERY}/senatran`;
export const ENDPOINT_VIOLATIONS_QUERY = `${API_URL_VERSION}infracoes`;
export const ENDPOINT_VIOLATIONS_QUERY_BY_PLACA = `${ENDPOINT_VIOLATIONS_QUERY}/placa`;
export const ENDPOINT_VIOLATIONS_QUERY_BY_CPF = `${ENDPOINT_VIOLATIONS_QUERY}/cpf`;
export const ENDPOINT_PAYMENTS_QUERY = `${API_URL_VERSION}pagamentos-infracoes`;
export const ENDPOINT_PAYMENTS_QUERY_BY_VALUE = `${ENDPOINT_PAYMENTS_QUERY}/valor`;
export const ENDPOINT_VIOLATION_EVENTS_QUERY = `${API_URL_VERSION}infracoes/eventos`;
export const ENDPOINT_VIOLATION_EVENTS_BY_PLATE = `${ENDPOINT_VIOLATION_EVENTS_QUERY}/placa`;
export const ENDPOINT_VIOLATION_EVENTS_BY_CPF = `${ENDPOINT_VIOLATION_EVENTS_QUERY}/cpf`;
export const ENDPOINT_VEHICLES_QUERY_ADDRESS_SENATRAN = `${ENDPOINT_VEHICLES_QUERY_SENATRAN}/endereco/placa`;
export const ENDPOINT_VEHICLES_QUERY_SCORE_HISTORY = `${ENDPOINT_DRIVERS_QUERY}/:id/historico`;
export const ENDPOINT_VEHICLES_QUERY_PROCESS_BLOCKERS = `${ENDPOINT_DRIVERS_QUERY}/:id/bloqueios`;
export const ENDPOINT_VIOLATION_HISTORY_DETRAN = `${API_URL_VERSION}detranws/infracao`;

export const queryService = {
  findVehicleByPlate: async (plate, isSenatran = false) => {
    try {
      const url = isSenatran
        ? `${ENDPOINT_VEHICLES_QUERY_BY_PLATE_SENATRAN}/${plate}`
        : `${ENDPOINT_VEHICLES_QUERY_BY_PLATE}/${plate}`;
      const { data } = await api.get(url);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-vehicle";
    }
  },

  findVehicleByChassis: async (chassis, isSenatran = false) => {
    try {
      const url = isSenatran
        ? `${ENDPOINT_VEHICLES_QUERY_BY_CHASSIS_SENATRAN}/${chassis}`
        : `${ENDPOINT_VEHICLES_QUERY_BY_CHASSIS}/${chassis}`;
      const { data } = await api.get(url);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-vehicle";
    }
  },

  findVehicleByCpfCnpj: async (cpfCnpj, isSenatran = false) => {
    try {
      const url = isSenatran
        ? `${ENDPOINT_VEHICLES_QUERY_BY_CPFCNPJ_SENATRAN}/${cpfCnpj}`
        : `${ENDPOINT_VEHICLES_QUERY_BY_CPFCNPJ}/${cpfCnpj}`;
      const { data } = await api.get(url);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-vehicle";
    }
  },

  findDriverByCpf: async (cpf, isSenatran = false) => {
    try {
      const url = isSenatran
        ? `${ENDPOINT_DRIVERS_QUERY_SENATRAN}/${cpf}`
        : `${ENDPOINT_DRIVERS_QUERY}/${cpf}`;
      const { data } = await api.get(url);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-driver";
    }
  },

  findViolationsByPlaca: async (placa) => {
    try {
      const { data } = await api.get(`${ENDPOINT_VIOLATIONS_QUERY_BY_PLACA}/${placa}`);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-violations";
    }
  },

  findViolationsByCpf: async (cpf) => {
    try {
      const { data } = await api.get(`${ENDPOINT_VIOLATIONS_QUERY_BY_CPF}/${cpf}`);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-violations";
    }
  },

  findPaymentsByValue: async (valor) => {
    try {
      const { data } = await api.get(`${ENDPOINT_PAYMENTS_QUERY_BY_VALUE}/${valor}`);
      return data;
    } catch (error) {
      throw (
        error.response?.data?.message || "queries.messages.errors.find-violation-payments"
      );
    }
  },

  findViolationEvents: async (value, type = "placa") => {
    try {
      const base =
        type === "cpf"
          ? ENDPOINT_VIOLATION_EVENTS_BY_CPF
          : ENDPOINT_VIOLATION_EVENTS_BY_PLATE;

      const { data } = await api.get(`${base}/${value}`);
      return data;
    } catch (error) {
      throw (
        error.response?.data?.message || "queries.messages.errors.find-violation-events"
      );
    }
  },

  findDriverAddressByPlate: async (plate) => {
    try {
      const url = `${ENDPOINT_VEHICLES_QUERY_ADDRESS_SENATRAN}/${plate}`;
      const { data } = await api.get(url);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-owner-address";
    }
  },
  findDriverScoreHistory: async (cpf) => {
    try {
      const { data } = await api.get(`${ENDPOINT_VEHICLES_QUERY_SCORE_HISTORY}`.replace(':id', cpf));
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-driver-history";
    }
  },
  findDriverProcessBlockers: async (cpf) => {
    try {
      const { data } = await api.get(`${ENDPOINT_VEHICLES_QUERY_PROCESS_BLOCKERS}`.replace(':id', cpf));
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-driver-blockers";
    }
  },

  findViolationHistoryDetran: async (numeroAit) => {
    try {
      const { data } = await api.get(`${ENDPOINT_VIOLATION_HISTORY_DETRAN}/${numeroAit}/historico`);
      return data;
    } catch (error) {
      throw error.response?.data?.message || "queries.messages.errors.find-violation-history-detran";
    }
  }
};